window.addEventListener("load", function () {    

    // Initialize Swiper gallery
    if (typeof Swiper !== 'undefined') {
        var swiperGallery = new Swiper('.swiper-gallery', {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 0,
            navigation: {
                nextEl: '#group-qua .swiper-button-next',
                prevEl: '#group-qua .swiper-button-prev',
            },
            loop: false,
            speed: 500,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 20,
                }
            }
        });
    }

});